import React from 'react';
import { TrendingUp, Shield, Users, Landmark } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
const benefits = [{
  icon: <TrendingUp className="w-10 h-10 text-deep-blue" data-id="element-1" />,
  title: 'Crecimiento Seguro',
  description: 'Crecimiento anual de hasta un 10% sin riesgo de pérdida.'
}, {
  icon: <Shield className="w-10 h-10 text-deep-blue" data-id="element-2" />,
  title: 'Protección en Vida',
  description: 'Protección financiera en caso de enfermedades graves o accidentes.'
}, {
  icon: <Users className="w-10 h-10 text-deep-blue" data-id="element-3" />,
  title: 'Respaldo Familiar',
  description: 'Garantiza un respaldo económico para tus hijos y seres queridos.'
}, {
  icon: <Landmark className="w-10 h-10 text-deep-blue" data-id="element-4" />,
  title: 'Retiro Independiente',
  description: 'Construye un plan de ahorro para tu retiro, sin depender del Estado.'
}];
export function Benefits() {
  return <section className="bg-white py-24" data-id="element-5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-6">
        <FadeInUp data-id="element-7">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-8">
            <h2 className="text-3xl md:text-4xl font-bold text-deep-blue mb-4" data-id="element-9">
              ¿Qué es un IUL y cómo te beneficia?
            </h2>
            <div className="w-24 h-1 bg-vitality-green mx-auto rounded-full" data-id="element-10"></div>
          </div>
        </FadeInUp>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-11">
          {benefits.map((benefit, index) => <FadeInUp key={index} delay={index * 0.1} data-id="element-12">
              <div className="text-center group" data-id="element-13">
                <div className="mx-auto w-20 h-20 bg-blue-50 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-vitality-green/10 transition-colors duration-300" data-id="element-14">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-15">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-16">
                  {benefit.description}
                </p>
              </div>
            </FadeInUp>)}
        </div>
      </div>
    </section>;
}